import {klipIndex} from '@/router/klip-index';
import {useUserStore} from '@/app/shared/state/UserDataModule';
import {EUserRole} from '@/app/shared/state/user-role';
import { PaymentTypes } from '@/api/klip-api.proxy';
import {RouteRecordRaw} from 'vue-router';

export const Prepaid: RouteRecordRaw = {
  path: '/prepaid',
  name: 'prepaid',
  component: () => import('./prepaid.vue'),
  meta: {
    authorize: { roles: [EUserRole.mri, EUserRole.mrr] }, // TODO: Check roles
    breadcrumb: { title: 'Prepaid saldo', parent: klipIndex },
  },
  beforeEnter: (to, from, next) => {
    if (useUserStore().user.paymentType !== PaymentTypes.Invoice && !useUserStore().user.isCitizen ) {
      next();
    } else {
      next({ name: 'mri'});
    }
  },
};

export default [
  Prepaid,
];
